<template>
  <div class="flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="flex flex-column align-items-center justify-content-center">
      <div style="border-radius:56px; padding:0.3rem; background:white;">
        <div
          class="w-full surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center"
          style="border-radius:53px"
        >
          <span class="text-2xl font-medium text-900 mb-4">Vocab</span>
          <span class="text-600 font-medium mb-5">Sign in with an authorized Google account</span>
          <div
            ref="googleButton"
            class="google-button"
            :class="{ 'opacity-50': loading }"
          />
          <Message
            v-if="error"
            severity="error"
            :closable="false"
            class="mt-4 w-full"
          >
            {{ error }}
          </Message>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Message from 'primevue/message'
import { mapActions } from 'vuex'
import { userService } from '../service'
import { renderGoogleButton } from '../service/google-identity.service'

export default {
  components: { Message },
  data () {
    return {
      loading: true,
      error: ''
    }
  },
  async mounted () {
    try {
      const response = await userService.getGoogleConfig('dashboard')
      await renderGoogleButton({
        element: this.$refs.googleButton,
        clientId: response.data.client_id,
        callback: this.handleGoogleCredential
      })
    } catch (error) {
      this.error = error.message || 'Unable to load Google Sign-In.'
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions({ loginWithGoogle: 'auth/loginWithGoogle' }),
    async handleGoogleCredential ({ credential }) {
      if (!credential || this.loading) return
      this.loading = true
      this.error = ''
      try {
        await this.loginWithGoogle(credential)
        const redirect = typeof this.$route.query.redirect === 'string' ? this.$route.query.redirect : '/'
        await this.$router.push(redirect)
      } catch (error) {
        this.error = error.status === 403
          ? 'This Google account is not authorized.'
          : (error.message || 'Unable to sign in with Google.')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.google-button {
  width: 320px;
  min-height: 44px;
  display: flex;
  justify-content: center;
}
</style>
